export const overflowlist = [
  {
    label: 'Default',
    value: '',
  },		
  {
    label: 'Visible',
    value: 'visible',
  },							
  {
    label: 'hidden',
    value: 'hidden',
  },
  {
    label: 'Scroll',
    value: 'scroll',
  },
  {
    label: 'Scroll X',
    value: 'scroll-x',
  },		
  {
    label: 'Scroll Y',
    value: 'scroll-y',
  },									
  {
    label: 'auto',
    value: 'auto',
  }          
]